// One-shot handoff of the parent's first name from the passwordless signup
// form (CreateAccountPage) to profile sync. The magic-link login returns
// without the name, so we stash it here and read it once after sync.

export const PENDING_NAME_KEY = 'hopscotch.pending_first_name'

export function setPendingFirstName(name: string): void {
  try {
    localStorage.setItem(PENDING_NAME_KEY, name)
  } catch {
    /* ignore storage failures */
  }
}

export function readPendingFirstName(): string | null {
  try {
    return localStorage.getItem(PENDING_NAME_KEY)
  } catch {
    return null
  }
}

export function clearPendingFirstName(): void {
  try {
    localStorage.removeItem(PENDING_NAME_KEY)
  } catch {
    /* ignore */
  }
}
